<!-- 添加建筑表单 -->
<template>
    <el-dialog title="定时分类" :visible.sync="visible" width="700px" :before-close="handleCloseDialog">
        <el-dialog
            width="500px"
            title="节点名称"
            :visible.sync="innerVisible"
            append-to-body>
            <el-form :model="form" ref="nodeForm">
                <el-form-item label="分类名称" label-width="100px" prop="name"
                :rules="[
                    { required: true, message: '请输入分类名称', trigger: 'blur' }
                ]">
                    <el-input v-model="form.name" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleReset">取 消</el-button>
                <el-button type="primary" @click="handleSaveName">确 定</el-button>
            </div>
        </el-dialog>
        <el-tree
            :data="treeData"
            node-key="id"
            default-expand-all
            :expand-on-click-node="false">
            <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>{{ node.label }}</span>
                <span style="margin-left:25px;">
                     <el-button type="text" size="mini" icon="el-icon-edit" @click="() => edit(data)">
                        </el-button>  
                     <el-button type="text" size="mini" icon="el-icon-plus" @click="() => append(data)">
                        </el-button>
                    <el-button type="text" v-if="data.pid?true : false" size="mini" icon="el-icon-delete" @click="() => remove(node, data)">
                        </el-button>
                </span>
            </span>
        </el-tree>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleCloseDialog">取 消</el-button>
            <el-button type="primary" @click="handleSave">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import Service from '@/api/Service'
import {$Alert, getGuid} from '@/utils/utils'


export default {
    name:  'CmpTimingClassify',
    props: ["visible"],
    inject: ['reload'],
    data() {
        const data = [{
            id: getGuid(),
            label: '定时分类',
            children: []
        }];
        return {
            innerVisible: false,
            treeKey: "",
            form: {
                name: '',
            },
            editType: "",
            activeData: {}, //  当前节点数据
            treeData: JSON.parse(JSON.stringify(data)),
            OID: '',
        };
    },
    mounted() {
       this.handleInitData()
    },
    methods: {
        // 刷新key值，重新渲染tree
        renderTree() {
            this.treeKey = +new Date();
        },
        async handleInitData() {
            this.$store.dispatch("getTimerKind").then(res=>{
                this.OID = res.OID;
                this.treeData = JSON.parse(res.Timerkind);
            }).catch(res=>{
            })
        },
        // 关闭弹框
        handleCloseDialog() {
            this.$emit("handleCloseDialog", {flag: false});
        },
        // 确认选择
        async handleSave() {
            let data
            let treejson = JSON.stringify(this.treeData).replace(",\"children\":null","").replace(",\"children\":[]","")
            if(!this.OID) {
                // 添加
                data = await Service.addTimerKind({timer_kind: treejson});
            }else {
                // 修改
                data = await Service.editTimerKind({oid: this.OID, timer_kind: treejson});
            }
            
            if(data) {
                this.$message({
                    type: 'success',
                    message: '操作成功',
                })
                
                this.reload();
            }
            return
            
        },
        // 编辑节点
        edit(data) {
            this.form.name = data.label;
            // 记录当前操作数据
            this.activeData = data;
            this.editType = "EDIT"
            this.innerVisible = true;
        },
        append(data) {
            // 记录当前操作数据
            this.activeData = data;
            this.editType = "ADD"
            this.innerVisible = true;
        },
        handleSaveName() {
            this.$refs["nodeForm"].validate(valid => {
                if (valid) {
                    let name = this.form.name;
                    this.editType === "ADD" ? this.appendCallback(name) : this.editCallback(name);
                    this.handleReset();
                } else {
                    return false;
                }
            });
        },
        handleReset() {
            this.activeData = null;
            this.editType = ""
            this.innerVisible = false;
            this.$refs["nodeForm"].resetFields()
        },
        // 编辑节点
        editCallback(name) {
            const data = this.activeData;
                // 将节点新名称和节点id传递到后台
                data.label = name;
                this.$message({
                    type: "success",
                    message: "修改成功！"
                });
                this.renderTree();
        },
        // 新增节点
        appendCallback(name) {
            let data = this.activeData;
            const newChild = { id: getGuid(), label: name, pid: data.id };
            if (!data.children) {
                this.$set(data, 'children', []);
            }
            data.children.push(newChild);
        },
        // 删除节点
        remove(node, data) {
            $Alert(`确认删除${data.label}, 是否继续?`).then( async (bool)=>{
                if(bool){
                    const parent = node.parent;
                    const children = parent.data.children || parent.data;
                    const index = children.findIndex(d => d.id === data.id);
                    children.splice(index, 1);
                    // if(children.length<=0)
                    // {
                    //    // const tindex = parent.findIndex(d =>parent.children === children)
                    //     this.$delete(parent.data,"children") 
                    // }
                    this.$message({
                        type: "success",
                        message: "删除成功"
                    });
                }
            });
        },

    }
}

</script>
<style lang='less' scoped>

</style>